import React, { useState } from 'react'
import Navbar from './Navbar/Navbar';
import Hero from './Hero/Hero';
import Features from './Features/Features';
import Avantages from './Avantages/Avantages';
import About from './About/About';
import CTA from './CTA/CTA';
import Popup from '../Popup/Popup';
import s from './Home.module.css';

export default function Home() {
  const [showPopup, setShowPopup] = useState(false);

  const handleShowPopup = () => {
    setShowPopup(true);
  };

  return (
    <div className={s.home}>
       <Navbar onShowPopup={handleShowPopup} /> 
       <Hero onShowPopup={handleShowPopup} /> 
       <About/>
       <Features/>
       <Avantages/>
       <CTA onShowPopup={handleShowPopup} />
       <Popup isOpen={showPopup} onClose={() => setShowPopup(false)} />
        
    </div>
  )
}
